import { ReactNode } from 'react';
import { Card } from '@/components/ui/card';

interface AdminPageLayoutProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  filters?: ReactNode;
  children: ReactNode;
}

export function AdminPageLayout({ 
  title, 
  subtitle, 
  actions, 
  filters, 
  children 
}: AdminPageLayoutProps) {
  return (
    <div className="space-y-6">
      {/* Header consistente */}
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-3xl font-bold">{title}</h1>
          {subtitle && (
            <p className="text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex gap-2">{actions}</div>
        )}
      </div>
      
      {/* Filtros globales */}
      {filters && (
        <Card className="p-4">
          <div className="flex gap-4 items-center flex-wrap">
            {filters}
          </div>
        </Card>
      )}
      
      {/* Contenido específico de cada vista */}
      <div>{children}</div>
    </div>
  );
}